// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Color } from '../../../Graphics';
import { PriceType } from '@shared/utils/History/CashItemUtils';
import { MAMode } from '../IndicatorConstants';
import { IndicatorScriptBase } from '../IndicatorScriptBase';
import { LineStyle } from '../IndicatorScriptBaseEnums';
import { InputParameterInteger } from '../InputParamaterClasses/InputParameterInteger';
import { InputParameterCombobox } from '../InputParamaterClasses/InputParameterCombobox';
export class Didi extends IndicatorScriptBase {
    constructor() {
        super();
        // #region Initialization
        this.DateOfCreation = '02.05.2020';
        this.ExpirationDate = 0;
        this.Version = '';
        this.ProjectName = 'Didi';
        // #endregion
        super.SetIndicatorLine('Fast Line', Color.Lime, 2, LineStyle.SimpleChart);
        super.SetIndicatorLine('Slow Line', Color.Yellow, 2, LineStyle.SimpleChart);
        this.SetLevelLine('Media Line', 1, Color.Red, 1, LineStyle.DotChart);
        this.SeparateWindow = true;
        this.Fast = 3;
        super.InputParameter(new InputParameterInteger('Fast', 'Fast line', 0, 1, 99999));
        this.Slow = 20;
        super.InputParameter(new InputParameterInteger('Slow', 'Slow line', 1, 1, 99999));
        this.Media = 8;
        super.InputParameter(new InputParameterInteger('Media', 'Media line', 2, 1, 99999));
        this.MAType = MAMode.SMA;
        super.InputParameter(new InputParameterCombobox('MAType', 'Type of Moving Average for Signal', 3, [
            { SMA: MAMode.SMA },
            { EMA: MAMode.EMA },
            { SMMA: MAMode.SMMA },
            { LWMA: MAMode.LWMA }
        ]));
    }
    Init() {
        this.IndicatorShortName(this.GetIndicatorShortName());
    }
    GetIndicatorShortName() {
        return 'Didi(fast: (' + this.Fast + '), slow: (' + this.Slow + ')';
    }
    getCustomName() {
        return 'Didi (' + this.ProjectName + ')';
    }
    createInternalIndicators() {
        this.long_handle = this.Indicators.iMA(this.CurrentData, this.Fast, this.MAType, 0, PriceType.Close);
        this.average_handle = this.Indicators.iMA(this.CurrentData, this.Slow, this.MAType, 0, PriceType.Close);
        this.short_handle = this.Indicators.iMA(this.CurrentData, this.Media, this.MAType, 0, PriceType.Close);
        return [this.long_handle, this.average_handle, this.short_handle];
    }
    OnQuote() {
        super.OnQuote();
        if (this.CurrentData.Count <= this.Media) {
            this.SetValue(0, 1);
        }
        else {
            this.SetValue(0, this.short_handle.GetValue(1) / this.average_handle.GetValue(1));
            this.SetValue(1, this.CurrentData.Count >= this.Slow ? this.long_handle.GetValue(1) / this.average_handle.GetValue(1) : 1);
        }
    }
}
